export function replacer(key, value) {
  if (key.startsWith('_')) return undefined;
  else return value === '' ? null : value;
}
